export default __webpack_public_path__ + "static/media/2SiteCooperando_Desktop_VetorClienteFala.dce9f4b3.png";